import React, { useState } from 'react';

function InviteUserModal({ isOpen, onClose, sendInvite }) {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('admin');

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleRoleChange = (event) => {
    setRole(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendInvite(email, role);
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="modal-backdrop"
        onClick={onClose}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            onClose();
          }
        }}
        tabIndex={-1}
        aria-hidden="true"
      />
      <div className="modal w-[400px]">
        <div className="modal-header">
          <h2 className="text-lg font-semibold text-surface-900">Invite User</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body space-y-4">
            <div>
              {/* eslint-disable */}
              <label htmlFor="email" className="block text-xs font-medium text-surface-500 uppercase tracking-wider mb-1.5">
                {/* eslint-enable */}
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={handleEmailChange}
                className="input"
                placeholder="user@example.com"
                required
              />
            </div>
            <div>
              {/* eslint-disable */}
              <label htmlFor="role" className="block text-xs font-medium text-surface-500 uppercase tracking-wider mb-1.5">
                {/* eslint-enable */}
                Role
              </label>
              <select
                id="role"
                name="role"
                value={role}
                onChange={handleRoleChange}
                className="input"
              >
                <option value="admin">Admin</option>
                <option value="basic_member">Basic Member</option>
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-accent"
            >
              Send Invite
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default InviteUserModal;
